import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {Observable} from 'rxjs';
import {SideNavService, SideNavState} from '../../services/side-nav.service';
import {SideNavItem} from './models/side-nav-item';
import {Router} from '@angular/router';
import {BreakpointService} from '../../../shared/services/breakpoint.service';
import {delay, distinctUntilChanged, filter, mergeMap, take, takeUntil} from 'rxjs/operators';
import {Disposable} from '../../../shared/extensions/disposable';
import {adminNavItems} from './admin/admin-nav-items';
import {UserProfileService} from "../../../auth/services/user-profile.service";
import {UserClient} from "../../../shared/apis/api.client";

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent extends Disposable implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  sideNavItems$: Observable<SideNavItem[]>;

  constructor(private readonly sideNavService: SideNavService,
              private readonly breakpointService: BreakpointService,
              private router: Router,
              private userProfileService: UserProfileService,
              private userClient: UserClient) {
    super();
  }

  get sideNavState$(): Observable<SideNavState> {
    return this.sideNavService.sideNavState$;
  }

  ngOnInit(): void {
    this.userProfileService.currentUserProfile$.pipe(
        take(1),
        filter(user => user?.roles && user.roles.length > 0),
        mergeMap(user => this.userClient.getByAzureId(user.azureId))
    ).subscribe(profile => {
      this.sideNavService.setSideNavItems(adminNavItems);
      this.sideNavItems$ = this.sideNavService.getSideNavItems();
      if (profile?.user?.agencyId) {
        const agencyAdminNav = adminNavItems.find(a => a.title === 'AGENCIES');
        const child = agencyAdminNav.children.find(c => c.title === 'Manage my Agency');
        const agencyId = profile.user.agency.uwAgencyNumber;
        if (child) {
          child.route = [`/agencies/view/${agencyId}`];
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.sideNavService.setSidenav(this.sidenav);
    setTimeout(() => {
      this.breakpointService.isHandset$
          .pipe(takeUntil(this.$destroyed))
          .subscribe(isHandset => {
            this.sideNavService.toggleOnScreenChanged(isHandset);
          });
    });
  }

  toggleSideNav(): void {
    this.sideNavService.toggle();
  }

}
